import { MenuItem, TextField, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, FormHelperText } from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import React, { Fragment, useState } from "react";
import { Controller } from "react-hook-form";
import "../../../components/client/pages/tabs/Information/ClientInformation.css";

function ControlledField({ control, name, options, rules, setSelected, ...rest }) {
  const [focus, setFocused] = useState(false);
  const [hasValue, setHasValue] = useState(false);

  const onFocus = () => setFocused(true);

  const handleChange = event => {

    const { name, value } = event.target;

    let parsedValue;
    try {
      parsedValue = JSON.parse(value);
    } catch (err) {
      parsedValue = value;
    }

    if (setSelected) {
      setSelected(parsedValue);
    }

    return { target: { name: name, value: parsedValue } };
  }

  return (
    <Controller
      render={({
        field: { onChange, onBlur, value, name, ref },
        formState: { errors, isValid },
      }) => {
        if (rest?.type === 'date') {
          return (
            <LocalizationProvider dateAdapter={AdapterDateFns} sx={{ padding: '0px !important' }}>
              <DesktopDatePicker
                value={value}
                inputFormat="dd/MM/yyyy"
                variant="outlined"
                name={name}
                //onChange={onChange}
                onChange={(newValue) => {
                  // Corriger le problème de fuseau horaire
                  if (newValue) {
                    // Créer une nouvelle date à minuit en heure locale
                    const correctedDate = new Date(
                      newValue.getFullYear(),
                      newValue.getMonth(),
                      newValue.getDate(),
                      12, // Midi pour éviter les problèmes de DST
                      0,
                      0,
                      0
                    );
                    onChange(correctedDate);
                  } else {
                    onChange(newValue);
                  }
                }}
                onFocus={onFocus}
                onBlur={onBlur}
                error={!isValid}
                inputRef={ref}
                renderInput={(params) => <TextField {...params} />}
                type={hasValue || focus ? "date" : "text"}
                sx={{ padding: '2px !important' }}
                {...rest}
              />
            </LocalizationProvider>
          )
        } else if (rest?.type === 'radio') {
          return (
            <FormControl 
              component="fieldset" 
              error={errors && errors[name]}
              sx={{ 
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'row',
                gap: 2
              }}
            >
              <FormLabel 
                sx={{ 
                  marginRight: '10px',
                  alignSelf: 'center',
                  fontSize: '1rem',
                  color: 'black',
                }}
              >
                {rest?.label}
              </FormLabel>
              <RadioGroup
                value={value !== null && value !== undefined ? String(value) : 'null'}
                onChange={(e) => {
                  let parsedValue;
                  const val = e.target.value;
                  
                  // Gérer les valeurs spéciales
                  if (val === 'true') {
                    parsedValue = true;
                  } else if (val === 'false') {
                    parsedValue = false;
                  } else if (val === 'null') {
                    parsedValue = null;
                  } else {
                    try {
                      parsedValue = JSON.parse(val);
                    } catch (err) {
                      parsedValue = val;
                    }
                  }
                  
                  onChange(parsedValue);
                  if (setSelected) {
                    setSelected(parsedValue);
                  }
                }}
                name={name}
                row
                sx={{
                  alignItems: 'center'
                }}
              >
                {options?.map((option, index) => (
                  <FormControlLabel
                    key={(option?.name || option) + "" + index}
                    value={option?.value !== null ? String(option?.value) : 'null'}
                    control={<Radio />}
                    label={option?.name || option}
                    sx={{
                      alignItems: 'center',
                      margin: 0,
                      marginRight: '16px'
                    }}
                  />
                ))}
              </RadioGroup>
              {errors && errors[name] && (
                <FormHelperText sx={{ marginTop: 1 }}>{errors[name]?.message}</FormHelperText>
              )}
            </FormControl>
          )
        } else {
          return (
            <TextField 
              id="test"
              onBlur={onBlur}
              onChange={rest?.type === "select" ? (e => { onChange(handleChange(e)); }) : onChange}
              value={(value === null || (value === undefined)) ? "" : ((typeof value === 'object') ? JSON.stringify(value) : value)}
              inputRef={ref}
              color="primary"
              variant="outlined"
              error={!isValid}
              select={Boolean(options)}
              helperText={errors && errors[name]?.message}
              name={name}
              {...rest}
            >
              {options?.map((option, index) => (
                <MenuItem
                  id="test"
                  key={(option?.name || option) + "" + index}
                  value={option?.value
                    ? ((typeof option?.value === 'object') ? JSON.stringify(option.value) : option.value)
                    : option
                  }
                >
                  {option?.name || option}
                </MenuItem>
              )) || (
                  <MenuItem id="test">
                    <Fragment />
                  </MenuItem>
                )}
            </TextField>
          )
        }
      }
      }
      name={name}
      control={control}
      defaultValue={rest.defaultValue ?? ""}
      rules={{
        required: rest.required && {
          value: true,
          message: rest.label + " est requis",
        },
        ...rules,
      }}
    />
  )
};

export default ControlledField;
